//-- React Standard
import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { paymentTypesActions } from '../../_actions';
import { apiConstants } from '../../_constants/api.constants';

class PaymentTypes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // totalPage: '',
            // totalDataCount: '',
            // currentPage: 1,
            getPaymentTypesList: [],
        };
        this.handleChange = this.handleChange.bind(this);
    }

    /*
    * componentDidMount - Initially it will call and get the paymentTypes data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "_id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;
        postData.role = this.state.roleType;

        dispatch(paymentTypesActions.getPaymentTypesList(apiConstants.GET_PAYMENT_TYPES, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    * componenentDidUpdate()
    */
    componentWillReceiveProps(props) {
        if (props.getPaymentTypesList) {
            if (props.getPaymentTypesList.getPaymentTypesList) {
                if (props.getPaymentTypesList.getPaymentTypesList.data) {

                    this.setState({
                        // totalPage: props.getPaymentTypesList.getPaymentTypesList.data.totalPages,
                        // totalDataCount: props.getPaymentTypesList.getPaymentTypesList.data.totalCount,
                        getPaymentTypesList: props.getPaymentTypesList.getPaymentTypesList.data,
                    })
                }
            }
        }
    }





    //handle change of checkbox
    handleChange(e, id) {
        const { dispatch } = this.props;
        this.setState({ isChecked: e.target.checked })
        let postData = {};
        postData.id = id;
        postData.status = e.target.checked;
        //console.log("RRRRRRRRRRRRRRRRRRRRR ", e.target.checked);
        let getListData = {};
        getListData.api = apiConstants.GET_PAYMENT_TYPES;
        getListData.page = this.state.currentPage;
        getListData.orderBy = "_id";
        getListData.orderByAscDesc = "ASC";
        getListData.roleType = this.state.roleType;
        getListData.perPage = this.state.perPage;

        dispatch(paymentTypesActions.updateStatus(apiConstants.UPDATE_PAYMENT_TYPE_STATUS, postData, getListData));

    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
console.log("STATE ",this.state.getPaymentTypesList);
        return (
            <div id="wrapper">
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />

                        <Fragment>
                            <nav className="" aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="/settings">{siteConstants.MENU_SETTINGS}</a>
                                    </li>
                                    <li className="active breadcrumb-item" aria-current="page">
                                        {siteConstants.MENU_PAYMENT_TYPE}
                                    </li>
                                    <li style={{ paddingLeft: "680px" }}>
                                        <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                        </a>
                                    </li>
                                </ol>
                            </nav>

                            {/* <!-- Begin Page Content --> */}
                            {/* Checking the condition for detail list */}
                            <div className="container-fluid">

                                <h1 className="h3 mb-8 text-gray-800 fontBold">{siteConstants.MENU_PAYMENT_TYPE}</h1>

                                <div className="card shadow mb-4">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-bordered" width="100%" cellSpacing="0">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                        <th scope="col">{siteConstants.GEN_TITLE}</th>
                                                        <th scope="col">{siteConstants.GEN_LOGO}</th>
                                                        <th scope="col" width="8%">{siteConstants.LABEL_STATUS}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.getPaymentTypesList != undefined && this.state.getPaymentTypesList.length > 0 ? this.state.getPaymentTypesList.map((paymentTypes, index) => {
                                                            let dob = '';
                                                            if (paymentTypes.dob !== undefined) { dob = new Date(paymentTypes.dob); }
                                                            return (
                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{paymentTypes.title}</td>
                                                                    <td>
                                                                    <img src={`${config.imgPath}` + '/images/paymentTypeLogo/' + paymentTypes.logo} />
                                                                    </td>
                                                                    <td className="tdTextCenter">
                                                                        <div className="custom-control custom-checkbox small">
                                                                            <input type="checkbox" className="form-check-input" htmlFor="customCheck" id="customCheck"
                                                                                name={['isChecked' + index]} checked={paymentTypes.status === 1}
                                                                                onChange={(e) => this.handleChange(e, paymentTypes._id)} />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                                <td colSpan="4" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                            </tr>
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Fragment>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>
            </div>
        );
    }
}

//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getPaymentTypesList, language } = state;
    return {
        getPaymentTypesList,
        language
    };
}

const connectedPaymentTypes = connect(mapStateToProps)(PaymentTypes);
export { connectedPaymentTypes as PaymentTypes };
